<!--
 * @Author: ningbo.kang
 * @Date: 2020-01-15 14:50:06
 * @LastEditors: ningbo.kang
 * @LastEditTime: 2020-08-20 09:56:18
 * @Description: 联动
 -->

<template>
  <div :title="text.join('/')" widget-type="cascader">
    <a-cascader v-model="text"
      :size="size"
      :data-model="fieldName"
      :disabled="disabled"
      :placeholder="disabled?'':placeholder"
      :class="options.customClass"
      :options="selectList"
      :showSearch="options.filterable"
      @change="handleChange" />
  </div>
</template>
<script>
import baseMixin from '../../lib/baseMixin';
// import { compareProperty } from '../../lib';

export default {
  mixins: [baseMixin],
  data() {
    return {
      options: {
        defaultValue: '',
        disabled: false,
        clearable: false,
        placeholder: '',
        required: false,
        showLabel: false,
        width: '',
        options: [],
        remote: false,
        remoteType: 'func',
        remoteOption: '',
        filterable: false,
        remoteOptions: [],
        props: {
          value: 'value',
          label: 'label',
        },
        remoteFunc: '',
        customClass: '',
        labelWidth: 100,
        isLabelWidth: false,
        hidden: false,
        dataBind: true,
      },
      selectList: [],
    };
  },

  mounted() {
    this.initOptions();
  },
  methods: {
    initVal(val) {
      if (val) {
        this.text = val.split(',');
      } else {
        this.text = [];
      }
    },
    handleChange(val, selectedOptions) {
      if (!this.isNested) {
        const { rowIndex, fieldName: field } = this;
        const value = {
          type: 'cascader',
          rowIndex,
          field,
          value: val.join(),
          selectedItems: selectedOptions,
        };
        this.dispatch('wgForm', `on-${this.fieldName}-change`, value);
      }
      // 将数据抛给上一层，主要是被子表格服务
      this.$emit('change', val.join(), { selectedItems: selectedOptions });
    },
    initOptions(otherArgs) {
      const {
        remote, remoteType, remoteOption, remoteFunc, remoteOptions, props,
      } = this.options;
      const { func, args } = this.separateFunc(remoteFunc);
      if (remote && remoteType === 'func') {
        if (this.remote[func]) {
          this.remote[func](
            (data) => {
              this.selectList = data.map((item) => {
                const newItem = {
                  value: item[props.value],
                  label: item[props.label],
                  deleteFlag: item.deleteFlag,
                  disabled: item.disabled || false,
                };
                const { children } = item;
                if (children) {
                  newItem.children = children;
                }
                return item;
              });
            },
            { args, otherArgs },
          );
        } else {
          this.selectList = remoteOptions;
        }
      } else if (remote && remoteType === 'option') {
        if (this.dynamic[remoteOption]) {
          this.selectList = this.dynamic[remoteOption];
        } else {
          this.selectList = remoteOptions;
        }
      } else {
        this.selectList = this.options.options;
      }
      // remoteType
    },
  },
};
</script>
